import { customerApiClient } from './customer-api-client';
import type {
  CustomerDashboardData,
  CustomerDashboardQuery,
} from '@/types/customer-dashboard.types';

export const customerDashboardService = {
  /** D-130 — `query.locationId` is validated server-side against the caller's
   * scope; every count in the response is computed from the same authorised
   * dataset as the lists it links to. */
  getDashboard: (query?: CustomerDashboardQuery): Promise<CustomerDashboardData> =>
    customerApiClient
      .get<CustomerDashboardData>('/customer-portal/dashboard', { params: query })
      .then((r) => r.data),
};
